import { Injectable } from '@angular/core'
import { setContext } from '@sentry/browser'
import { UserCredential } from 'firebase/auth'
import { environment } from 'environments/environment'
import { BaseFirebaseService } from '../../_jaettu-angular/base-firebase.service'

abstract class AppCheckKontekstinLisaavaFirebaseService extends BaseFirebaseService {
  override async authSignInWithCustomToken(token: string, forceRefreshAppCheck: boolean = true): Promise<UserCredential> {
    const kontekstinAvain = 'appCheck-' + this.app.name
    // Nollaa edellisen yrityksen konteksti, ettei se vuoda myöhempiin (onnistuneisiin tai muusta syystä epäonnistuviin) eventteihin globaalin Sentry-scopen kautta
    setContext(kontekstinAvain, null)
    try {
      return await super.authSignInWithCustomToken(token, forceRefreshAppCheck)
    } catch (error) {
      // Konteksti tarttuu ErrorHandlerin lähettämään Sentry-eventtiin, jotta siitä näkee
      // kumman Firebase-appin App Check -vaihto kirjautumisessa epäonnistui ja millä tavalla.
      // Appin nimi kontekstin avaimessa, jotta rinnakkaiset (Promise.all) epäonnistumiset
      // eivät ylikirjoita toisiaan globaalissa Sentry-scopessa.
      if (typeof error?.code === 'string' && error.code.startsWith('appCheck/')) {
        setContext(kontekstinAvain, {
          forceRefresh: forceRefreshAppCheck,
          virhekoodi: error.code,
          httpStatus: error.customData?.httpStatus,
          estonKesto: error.customData?.time,
        })
      }
      throw error
    }
  }
}

@Injectable()
export class FirebaseLemonator extends AppCheckKontekstinLisaavaFirebaseService {
  constructor() {
    super(environment.lemonatorFirebaseConfig, 'lemonator', environment.recaptchaSiteId)
  }
}

@Injectable()
export class FirebaseLemonaid extends AppCheckKontekstinLisaavaFirebaseService {
  constructor() {
    super(environment.lemonaidFirebaseConfig, 'lemonaid', environment.lemonaidRecaptchaSiteId)
  }
}
